// extracted by mini-css-extract-plugin
module.exports = {"root":"StoreBadge_root__qmDqb"};